export default __webpack_public_path__ + "static/pro-menu-fd00138d8d8dc6a2ff9d7c0060fccc94.png";